
import React from 'react';
import Header from './Header';
import User from './User';
import '../App.css';


const UserPage = () => {
  return (
    <div className='user-page'>
      <Header />
      <User />
    </div>
    
  );
};

export default UserPage;
